module.exports = __webpack_public_path__ + "static/media/gennieLogo.fd180ea6.svg";